import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  titleBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  title: {
    alignItems: 'center',
    justifyContent: 'center',
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
    },
  },
  icon: {
    margin: theme.spacing(1),
  },
  midGrid: {
    '@media print': {
      width: '100%',
      maxWidth: '100%',
      flexBasis: '100%',
    },
  },
  contentWidth: {
    width: '100%',
    margin: 'auto',
    position: 'relative',
    '@media print': {
      width: '100%',
      maxWidth: 100000,
    },
  },
  listHeader: {
    fontWeight: 'bold',
    margin: theme.spacing(1),
  },
}));

export default useStyles;
